/**
 * SVG mouth layers — extracted from the reference PREVIEW.html.
 * All coordinates target a 400×500 viewBox, matching the body canvas.
 */
import React from 'react';
import { MouthKey } from '@/config/buddyLayerMap';

interface Props {
  variant: MouthKey;
}

const MouthSmile = () => (
  <path d="M168 232 Q197 252 226 232" stroke="#1a0a00" strokeWidth="5" strokeLinecap="round" fill="none"/>
);

const MouthGrin = () => (
  <>
    <path d="M160 228 Q197 268 234 228" fill="#1a0a00"/>
    <path d="M163 230 Q197 265 231 230 Q220 252 197 256 Q174 252 163 230 Z" fill="#e8748a"/>
    <path d="M168 232 Q197 240 226 232 L226 242 Q197 248 168 242 Z" fill="white"/>
    <line x1="197" y1="232" x2="197" y2="242" stroke="#e8c0c0" strokeWidth="1.5" opacity="0.5"/>
    <ellipse cx="152" cy="236" rx="16" ry="9" fill="#e07050" opacity="0.25"/>
    <ellipse cx="242" cy="236" rx="16" ry="9" fill="#e07050" opacity="0.25"/>
  </>
);

const MouthNeutral = () => (
  <path d="M172 238 L222 238" stroke="#1a0a00" strokeWidth="5" strokeLinecap="round" fill="none"/>
);

const MouthFrown = () => (
  <path d="M168 248 Q197 230 226 248" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
);

const MouthOpen = () => (
  <>
    <ellipse cx="197" cy="242" rx="22" ry="18" fill="#1a0a00"/>
    <ellipse cx="197" cy="243" rx="17" ry="13" fill="#e8748a"/>
    <ellipse cx="197" cy="252" rx="11" ry="6" fill="#d4506a" opacity="0.7"/>
  </>
);

const MouthAngry = () => (
  <>
    <path d="M162 232 Q197 248 232 232 Q228 252 197 256 Q166 252 162 232 Z" fill="#1a0a00"/>
    <path d="M166 234 Q197 242 228 234 L228 243 Q197 249 166 243 Z" fill="white"/>
    <line x1="181" y1="234" x2="181" y2="243" stroke="#ddd" strokeWidth="1.5" opacity="0.6"/>
    <line x1="197" y1="234" x2="197" y2="243" stroke="#ddd" strokeWidth="1.5" opacity="0.6"/>
    <line x1="213" y1="234" x2="213" y2="243" stroke="#ddd" strokeWidth="1.5" opacity="0.6"/>
    <path d="M166 243 Q197 249 228 243 Q220 256 197 258 Q174 256 166 243 Z" fill="#c03040"/>
  </>
);

const MouthSmirk = () => (
  <>
    <path d="M172 238 Q192 248 224 234" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <circle cx="228" cy="234" r="3.5" fill="#c0622a" opacity="0.35"/>
  </>
);

const MOUTH_COMPONENTS: Record<MouthKey, React.FC> = {
  smile: MouthSmile,
  grin: MouthGrin,
  neutral: MouthNeutral,
  frown: MouthFrown,
  open: MouthOpen,
  angry: MouthAngry,
  smirk: MouthSmirk,
};

const BuddySvgMouth = React.memo(function BuddySvgMouth({ variant }: Props) {
  const MouthComponent = MOUTH_COMPONENTS[variant];
  return <MouthComponent />;
});

export default BuddySvgMouth;
